export const ROSACEA_GRADE_LEVELS = ['Ausente', 'Leve', 'Moderado', 'Grave'] as const

export type RosaceaGradeLevel = (typeof ROSACEA_GRADE_LEVELS)[number]

export interface RosaceaSubtypeOption {
    key: string
    label: string
    name: string
    description: string
    tooltip: string
}

export const ROSACEA_SUBTYPE_OPTIONS: RosaceaSubtypeOption[] = [
    {
        key: '1',
        label: 'Subtipo 1',
        name: 'Eritemato-telangiectásica',
        description: 'Rubor e vermelhidão persistente, com vasos sanguíneos visíveis',
        tooltip: 'Rubor facial frequente (flushing), eritema persistente na região central da face e telangiectasias visíveis, podendo haver leve edema e pele sensível.',
    },
    {
        key: '2',
        label: 'Subtipo 2',
        name: 'Pápulo-pustulosa',
        description: 'Vermelhidão persistente com pápulas e pústulas',
        tooltip: 'Eritema persistente associado a pápulas e pústulas inflamatórias na região central da face, geralmente sem comedões (o que a diferencia da acne).',
    },
    {
        key: '3',
        label: 'Subtipo 3',
        name: 'Fimatosa',
        description: 'Espessamento da pele, mais comum no nariz (rinofima)',
        tooltip: 'Espessamento cutâneo com aumento de volume e textura irregular, mais comum no nariz (rinofima), podendo também afetar queixo, testa, orelhas e pálpebras.',
    },
    {
        key: '4',
        label: 'Subtipo 4',
        name: 'Ocular',
        description: 'Olhos irritados, avermelhados e sensíveis',
        tooltip: 'Irritação, ardor e sensação de corpo estranho nos olhos, com hiperemia conjuntival, pálpebras inflamadas (blefarite) e maior sensibilidade à luz.',
    },
]

export type RosaceaGradeValue = Record<string, RosaceaGradeLevel | null>

export function createDefaultRosaceaGradeValue(): RosaceaGradeValue {
    const value: RosaceaGradeValue = {}
    for (const option of ROSACEA_SUBTYPE_OPTIONS) value[option.key] = null
    return value
}

export function isRosaceaGradeValueEmpty(value: RosaceaGradeValue | null | undefined): boolean {
    if (!value) return true
    return ROSACEA_SUBTYPE_OPTIONS.some((option) => value[option.key] == null)
}
